// extracted by mini-css-extract-plugin
module.exports = {"Experience":"Experience_Experience__1EfDW","anim":"Experience_anim__17-Ii","Timeline":"Experience_Timeline__2zw6b"};